// Le bloc Disponibilités V2 réutilise le même store/interactivité
// que le bloc v1. On importe donc simplement le view du bloc principal.
import '../disponibilites/view';

